import { OrMapProps } from '../../organisms'
import { AtIconInformative, AtIconInformativeProps } from '../../atoms'
import dynamic from 'next/dynamic'

export interface OrMapTileProps extends OrMapProps {
  dataTestId?: string
  details?: Pick<AtIconInformativeProps, 'icon' | 'label' | 'title'>[]
}

const DynamicMapLoader = dynamic(() => import('../../organisms').then((mod) => mod.OrMap), {
  ssr: false,
  loading: () => (
    <div className="h-[28.125rem] sm:h-[32.5rem] slg:h-[22rem] lg:h-[23rem] bg-gray-200 animate-pulse flex items-center justify-center">
      <div className="w-[50px] h-[50px] animate-spin rounded-full border-2 border-current border-t-transparent" />
    </div>
  ),
})

export const OrMapTile = ({ details, dataTestId = 'or-map-tile', ...map }: OrMapTileProps) => (
  <div className="w-full">
    <DynamicMapLoader {...map} />
    <div data-testid={dataTestId} className="mt-6 lg:mt-8 grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-y-8">
      {details?.map((d, i) => (
        <AtIconInformative key={i} {...d} />
      ))}
    </div>
  </div>
)
